import axios from 'axios';
import { get, has } from 'lodash';
import { CONSTANTS } from '../constants';
import HttpResponse, { HttpStatus } from './HttpResponse';

export default class HttpClient
{
    constructor()
    {
        this.client = null;
    }

    getClient()
    {
        if (this.client === null)
        {
            this.client = axios.create({
                baseURL: CONSTANTS.HTTP_REQUEST.ENDPOINT,
                timeout: CONSTANTS.HTTP_REQUEST.TIMEOUT,
                headers: CONSTANTS.HTTP_REQUEST.HEADERS,
                validateStatus()
                {
                    return true;
                },
                transformResponse: [(data) =>
                {
                    let parsedData = {};

                    try
                    {
                        parsedData = JSON.parse(data);
                    }
                    catch (ignore)
                    {
                        // TODO notify error logger
                        console.warn(ignore); // eslint-disable-line no-console
                    }

                    // TODO: CHANGE THIS TO HANDLE BOTH GUARDS
                    if (get(parsedData, 'message') === 'Unauthenticated.')
                    {
                        /* eslint-disable no-restricted-globals */
                        location.href = '/app/admin';
                    }

                    if (
                        has(parsedData, 'messages')
                        && has(parsedData, 'data')
                        && has(parsedData, 'responseCode')
                        && has(parsedData, 'status')
                    )
                    {
                        return formatSuccess(parsedData);
                    }

                    return formatUnknown(parsedData);
                }],
            });
        }

        return this.client;
    }

    /**
     *
     * @param method
     * @param url
     * @param data
     * @returns {Promise<HttpResponse>}
     */
    async request(method, url, data)
    {
        const response = new HttpResponse();
        response.status = HttpStatus.ERROR;
        response.messages.push('Whoops something went wrong. If the error continues, contact technical support.');
        response.response_code = 500;

        try
        {
            const r = await this.getClient().request({
                method, url, data,
            });

            response.messages = r.data.messages;
            response.response = r.data.response;
            response.response_code = r.data.response_code;
            response.status = r.data.status;
            response.httpClientResponse = r;
        }
        catch (ignore)
        {
            // TODO notify error logger
            console.warn(ignore); // eslint-disable-line no-console
        }

        return response;
    }

    download(method, url)
    {
        return axios.create({
            baseURL: CONSTANTS.HTTP_REQUEST.ENDPOINT,
            timeout: CONSTANTS.HTTP_REQUEST.TIMEOUT,
            headers: CONSTANTS.HTTP_REQUEST.HEADERS,
            validateStatus()
            {
                return true;
            },
        })
            .request({
                method,
                url,
                responseType: 'blob',
            })
            .then((response) =>
            {
                if (response.status !== 200) return formatUnknown(null);

                const blob = new Blob([response.data], { type: response.data.type });
                const Url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = Url;
                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'unknown';
                if (contentDisposition)
                {
                    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                    /* eslint-disable */
                    if (fileNameMatch.length === 2) fileName = fileNameMatch[1];
                    /* eslint-enable */
                }
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(Url);

                return formatSuccess({
                    messages: [],
                    data: null,
                    responseCode: 200,
                    status: HttpStatus.OK,
                });
            })
            .catch(error => formatUnknown(error));
    }
}

function formatSuccess(data)
{
    const response = new HttpResponse();
    response.messages = data.messages;
    response.response = data.data;
    response.response_code = data.responseCode;
    response.status = data.status;

    if (typeof data.response === 'string')
    {
        response.messages = data.messages;
    }

    return response;
}

function formatUnknown(data)
{
    const response = new HttpResponse();
    response.status = HttpStatus.ERROR;
    response.messages.push('Whoops something went wrong. If the error continues, contact technical support.');
    response.response = data;
    response.response_code = 500;

    return response;
}
